export const chatListaStyles = 
{
  'div': {
      boxSizing: 'border-box' as 'border-box',
      padding: '15px'
  },
  'typografia':{
      marginBottom:'15%'
  }
}